// extracted by mini-css-extract-plugin
export default {"page":"PrivacyPolicyPage_page__9PTuB","subtitle":"PrivacyPolicyPage_subtitle__lpx0K"};